import SpinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { mapState } from 'vuex'
import mascaras from '@/util/mascaras'
import cpfCnpjUtil from '@/util/cpfCnpj'
import cnpjMask from '@/util/cnpjMask'
import cnpj from '@/util/cnpj'
import * as authStorage from '@/modules/auth/storage'
import { mapActions } from 'vuex/dist/vuex.common.js'

const REGEX_LETRA = /[A-Za-z]/
const contemLetra = (valor) => REGEX_LETRA.test(valor)

export default {
  data () {
    return {
      formulario: {
        forma_pagamento: null,
        escritorio: {
          cartao: {
            nome_cartao: null,
            numero_cartao: null,
            validade_cartao: null,
            ccv_cartao: null,
            padrao: false,
            token: null,
            bandeira: null,
            cpf_cnpj: null
          }
        }
      },
      cpfCnpjFormatado: null
    }
  },
  mounted: function () {
    this.resetarDadosFormulario()
    this.$emit('definirFormulario', this.formulario)
  },
  components: {
    SpinnerProcessando
  },
  props: {
    apresentarDebitoAutomatico: {
      type: Boolean,
      default: true
    },
    styleCartao: {
      type: String
    },
    flagsDeControle: {},
    cartoes: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    isLoadingCartao: {
      type: Boolean,
      required: true
    },
    obterBandeiraProp: {
      required: true
    },
    obterBandeiraInputProp: {
      required: true
    },
    listaDeErros: {
      type: Object,
      required: true
    },
    bandeiraDoCartao: {
      required: true
    },
    desativarGerenciador: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cartaoPadraoLocal: {
      get () {
        return this.cartaoPadrao
      },
      set (cartaoPadrao) {
        this.$emit('definirCartaoPadrao', cartaoPadrao)
      }
    },
    cpfCnpj: {
      get () {
        return this.cpfCnpjFormatado
      },
      set (value) {
        this.cpfCnpjFormatado = value
        // value pode conter máscara parcial (ex: "MA.MSG.HTG/"); contemLetra preserva letras
        // antes de deveSerTratadoComoCnpj classificar, que exige length > 11 — ver L-48 / F-03
        this.formulario.escritorio.cartao.cpf_cnpj = contemLetra(value)
          ? cnpj.normalizarCnpj(value)
          : cpfCnpjUtil.normalizar(value)
      }
    },
    ...mapState('formaspagamento', ['estaCadastrandoCartao', 'formularioFormaDePagamentoCliente'])
  },
  methods: {
    ...mapActions('formaspagamento', ['ActionDefinirEstaCadastrandoCartao', 'ActionDefinirFormaPagamentoCliente']),
    resetarDadosFormulario () {
      this.formulario.escritorio.cartao.nome_cartao = authStorage.getNomeEmpresa()
      this.cpfCnpj = authStorage.getCpfCnpj()
    },
    obterBandeiraLocal (cartao) {
      return this.obterBandeiraProp(cartao)
    },
    cadastrarCartaoNovo (value) {
      this.resetarDadosFormulario()
      this.ActionDefinirEstaCadastrandoCartao(value)
    },
    obterBandeiraInputLocal (bandeira) {
      return this.obterBandeiraInputProp(bandeira)
    },
    excluirCartao (id) {
      this.$emit('excluirCartao', id)
    },
    selecionarCartao (index) {
      this.$emit('selecionarCartao', index)
    },
    cadastrarCartao () {
      this.$emit('cadastrarCartao')
    },
    determinarBandeiraDoCartao () {
      this.$emit('determinarBandeiraDoCartao')
    },
    mascaraDocumento (valor) {
      if (contemLetra(valor) || cpfCnpjUtil.deveSerTratadoComoCnpj(valor)) {
        return cnpjMask.obterMascaraCnpj(valor)
      }

      return mascaras.mascaraCpfCnpj(valor)
    }
  }
}
